import path from "node:path";
import { AssetManager } from "@skaile/workspaces/asset-manager";
import { SUPPORTED_DRIVER_TARGETS } from "@skaile/workspaces/core";
import { Command, Option } from "commander";
import pc from "picocolors";
import { kindColorPad, logInfo, logWarn, S } from "../helpers.ts";

/**
 * Creates the `skaile outdated` command.
 *
 * Checks which deployed assets are behind the upstream repo commit and prints
 * a table of outdated entries with their commit-behind count.
 *
 * @returns Configured {@link Command} ready for `program.addCommand()`.
 * @docLink cli/commands/misc#outdated
 */
export function makeOutdatedCommand(): Command {
  return new Command("outdated")
    .description("Check for assets behind their repo")
    .argument("[name]", "Check a specific asset (kind:name)")
    .option("--project-dir <path>", "Project directory", process.cwd())
    .addOption(
      new Option("--target <agent>", "Driver target")
        .default("claude-code")
        .choices(SUPPORTED_DRIVER_TARGETS),
    )
    .action((name: string | undefined, opts) => {
      const am = new AssetManager({
        projectDir: path.resolve(opts.projectDir),
        driverTarget: opts.target,
      });
      const entries = am.outdated();
      if (entries.length === 0) {
        logInfo("All assets are up to date.");
        return;
      }

      const filtered = name
        ? entries.filter((e) => `${e.kind}:${e.name}` === name || e.name === name)
        : entries;
      if (filtered.length === 0) {
        logInfo(`${name} is up to date.`);
        return;
      }

      const nameW = Math.max(4, ...filtered.map((e) => e.name.length));
      console.log();
      console.log(S.heading("  Outdated Assets"));
      console.log(`  ${S.rule(nameW + 40)}`);
      for (const e of filtered) {
        console.log(
          `  ${kindColorPad(e.kind)}  ${e.name.padEnd(nameW)}  ${S.dim(e.publisher)}  ${pc.yellow(`${e.behind} commit(s) behind`)}`,
        );
      }
      console.log();
      logWarn(`Run ${S.cmd("skaile update")} to re-deploy.`);
    });
}
